function iconProps() {
  return {
    width: 30,
    height: 30,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true,
  }
}

export function IconVisionRecognition() {
  return (
    <svg {...iconProps()}>
      <circle cx="12" cy="12" r="9" />
      <path d="M3 12h18" />
      <path d="M12 3c2.5 2.8 4 6 4 9s-1.5 6.2-4 9" />
      <path d="M12 3c-2.5 2.8-4 6-4 9s1.5 6.2 4 9" />
    </svg>
  )
}

export function IconVisionPartnerships() {
  return (
    <svg {...iconProps()}>
      <path d="M7 11l2.5-2.5a2 2 0 0 1 2.8 0L15 11" />
      <path d="M9 13l1.5 1.5a2 2 0 0 0 2.8 0L15 13" />
      <path d="M4 10V8l2-2" />
      <path d="M20 10V8l-2-2" />
      <path d="M10 16h4" />
    </svg>
  )
}

export function IconVisionExpansion() {
  return (
    <svg {...iconProps()}>
      <path d="M4 18V6" />
      <path d="M4 18h16" />
      <path d="M8 14V10" />
      <path d="M12 14V8" />
      <path d="M16 14V11" />
      <path d="M16 8l3-3" />
      <path d="M16 8h3" />
      <path d="M16 8v3" />
    </svg>
  )
}

export function IconVisionGrowth() {
  return (
    <svg {...iconProps()}>
      <path d="M12 21V10" />
      <path d="M8 14l4-4 4 4" />
      <path d="M7 18c1.5-2 3.5-3 5-3s3.5 1 5 3" />
      <path d="M9 8c.5-1.5 1.8-2.5 3-2.5s2.5 1 3 2.5" />
    </svg>
  )
}

export function IconVisionExcellence() {
  return (
    <svg {...iconProps()}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v2" />
      <path d="M12 20v2" />
      <path d="M4.22 4.22l1.42 1.42" />
      <path d="M18.36 18.36l1.42 1.42" />
      <path d="M2 12h2" />
      <path d="M20 12h2" />
      <path d="M4.22 19.78l1.42-1.42" />
      <path d="M18.36 5.64l1.42-1.42" />
    </svg>
  )
}

export function IconVisionValue() {
  return (
    <svg {...iconProps()}>
      <path d="M12 3l2.2 4.5 5 .7-3.6 3.5.9 5.1L12 14.8 7.5 16.8l.9-5.1L4.8 8.2l5-.7L12 3z" />
      <path d="M8 19l4 2 4-2" />
    </svg>
  )
}

export const aboutVisionIconMap = {
  recognition: IconVisionRecognition,
  partnerships: IconVisionPartnerships,
  expansion: IconVisionExpansion,
  growth: IconVisionGrowth,
  excellence: IconVisionExcellence,
  value: IconVisionValue,
}
